module.exports = __webpack_public_path__ + "static/media/clutchLogin.f737e600.webp";